import request from "@/config/request";
import tmhRequest from "@/config/tmhRequest";

export default {
  searchLastConsumeDate: function(data) {
    return tmhRequest({
      url: "/customer/customer/searchlastconsumedate",
      method: "GET",
      params: data
    });
  },
  registerCustomer: function(
    openId,
    mobile,
    userName,
    verifyCode,
    from,
    status
  ) {
    return request({
      url: "/customer/customer/registercustomer",
      method: "post",
      params: {
        openid: openId,
        mobile: mobile,
        username: userName,
        verifycode: verifyCode,
        from: from,
        status: status
      }
    });
  },
  searchCustomer: function(code) {
    return tmhRequest({
      url: "/customer/tmh/customer/searchcustomer",
      method: "get",
      params: {
        code: code
      }
    });
  },
  searchCustomerAssets: function(code) {
    return request({
      url: "/customer/customer/searchcustomerassets",
      method: "get",
      params: {
        code: code
      }
    });
  },
  logout: function(code) {
    return request({
      url: "/customer/customer/logout",
      method: "get",
      params: {
        code: code
      }
    });
  },
  editCustomer: function(code, userName, sex) {
    return request({
      url: "/customer/customer/editcustomer",
      method: "get",
      params: {
        code: code,
        username: userName,
        sex: sex
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/customer/customer.js